<template>
  <div>
    <vx-card no-shadow title="LIST OF SETTINGS">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateSettings)">
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col w-full">
              <ValidationProvider name="company_name" rules="required|max:255" v-slot="{ errors }" vid="company_name">
                <small class="label">Company Name</small>
                <vs-input class="w-full" name="company_name" type="text" v-model="createForm.company_name"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
<!--          <div class="vx-row mb-3 mt-4">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider name="address_line_1" rules="required|max:255" v-slot="{ errors }" vid="address_line_1">-->
<!--                <small class="label">Address Line 1</small>-->
<!--                <vs-input class="w-full" name="address_line_1" type="text" v-model="createForm.address_line_1"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider name="address_line_2" rules="max:255" v-slot="{ errors }" vid="address_line_2">-->
<!--                <small class="label">Address Line 2</small>-->
<!--                <vs-input class="w-full" name="address_line_2" type="text" v-model="createForm.address_line_2"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="vx-row mb-3 mt-4">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <small class="label">Address Line 3</small>-->
<!--              <vs-input class="w-full" name="address_line_3" type="text" v-model="createForm.address_line_3"/>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider name="town" rules="required" v-slot="{ errors }" vid="town">-->
<!--                <small class="label">Town</small>-->
<!--                <vs-input class="w-full" name="town" v-model="createForm.town"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="vx-row mb-3 mt-4">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider name="post_code" rules="required" v-slot="{ errors }" vid="post_code">-->
<!--                <small class="label">Post Code</small>-->
<!--                <vs-input class="w-full" name="post_code" type="text" v-model="createForm.post_code"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider name="country" rules="required" v-slot="{ errors }" vid="country">-->
<!--                <small class="label">Country</small>-->
<!--                <vs-input class="w-full" name="country" type="text" v-model="createForm.country"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="telephone" rules="" v-slot="{ errors }" vid="telephone">
                <small class="label">Telephone</small>
                <vs-input class="w-full" name="telephone" type="text" v-model="createForm.telephone"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <small class="label">Website</small>
              <vs-input class="w-full" name="website" type="text" v-model="createForm.website"/>
            </div>
          </div>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="vat_no" rules="" v-slot="{ errors }" vid="vat_no">
                <small class="label">VAT No</small>
                <vs-input class="w-full" name="vat_no" type="text" v-model="createForm.vat_no"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="company_no" rules="" v-slot="{ errors }" vid="company_no">
                <small class="label">Company No</small>
                <vs-input class="w-full" name="company_no" type="text" v-model="createForm.company_no"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider name="eori_eu" rules="" v-slot="{ errors }" vid="eori_eu">
                <small class="label">EORI for EU</small>
                <vs-input class="w-full" name="eori_eu" type="text" v-model="createForm.eori_eu"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider name="eori_ni" rules="" v-slot="{ errors }" vid="eori_ni">
                <small class="label">EORI for NI</small>
                <vs-input class="w-full" name="eori_ni" type="text" v-model="createForm.eori_ni"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider name="eori_nl" rules="" v-slot="{ errors }" vid="eori_nl">
                <small class="label">EORI for NL</small>
                <vs-input class="w-full" name="eori_nl" type="text" v-model="createForm.eori_nl"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full">
              <small class="label">Financial Year Start Month</small>
              <v-select v-model="createForm.financial_year_start_month"
                        :options="[
                          'January', 'February', 'March', 'April', 'May', 'June', 'July',
                          'August', 'September', 'October', 'November', 'December'
                          ]"/>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="bespoke_price_check_days" rules="" v-slot="{ errors }" vid="bespoke_price_check_days">
                <small class="label">Bespoke Price Age Warning ( set number of days after which the warning is to be shown )</small>
                <vs-input class="w-full" name="bespoke_price_check_days" type="text" v-model="createForm.bespoke_price_check_days"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="vat_deferred" rules="" v-slot="{ errors }" vid="vat_deferred">
                <small class="label">VAT Deferred</small>
                <vs-input class="w-full" name="vat_deferred" type="text" v-model="createForm.vat_deferred"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="default_sample_item_price" rules="" v-slot="{ errors }" vid="default_sample_item_price">
                <small class="label">Default Sample Price Per Unit (GBP/KG)</small>
                <vs-input class="w-full" name="default_sample_item_price" type="text" v-model="createForm.default_sample_item_price"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div>
            <h5 class="mb-4 mt-16">Sales Contact</h5>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Sales contact telephone</small>
                <vs-input class="w-full" name="sales_contact_tel" type="text" v-model="createForm.sales_contact_tel"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Sales contact email</small>
                <vs-input class="w-full" name="sales_contact_email" type="email" v-model="createForm.sales_contact_email"/>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Customer Service Contact Email</small>
                <vs-input class="w-full" name="customer_service_contact_email" type="email" v-model="createForm.customer_service_contact_email"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Technical Contact Email</small>
                <vs-input class="w-full" name="technical_contact_email" type="text" v-model="createForm.technical_contact_email"/>
              </div>
            </div>
          </div>

          <div>
            <h5 class="mb-4 mt-16">Banking Details</h5>
            <h6 class="mb-4 mt-6">GBP</h6>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank name</small>
                <vs-input class="w-full" name="payment_bank_name" type="text" v-model="createForm.payment_bank_name"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account name</small>
                <vs-input class="w-full" name="payment_bank_account_name" type="text" v-model="createForm.payment_bank_account_name"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider name="payment_bank_account_number" rules="max:255" v-slot="{ errors }" vid="payment_bank_account_number">
                  <small class="label">Payment bank account number</small>
                  <vs-input class="w-full" name="payment_bank_account_number" type="text" v-model="createForm.payment_bank_account_number"/>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider name="payment_bank_sort_code" rules="max:8" v-slot="{ errors }" vid="payment_bank_sort_code">
                  <small class="label">Payment bank sort code</small>
                  <vs-input class="w-full" name="payment_bank_sort_code" type="text" v-model="createForm.payment_bank_sort_code"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider name="payment_bank_iban" rules="max:30" v-slot="{ errors }" vid="payment_bank_iban">
                  <small class="label">Payment bank IBN</small>
                  <vs-input class="w-full" name="payment_bank_iban" type="text" v-model="createForm.payment_bank_iban"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider name="payment_bank_swiftbic" rules="max:10" v-slot="{ errors }" vid="payment_bank_swiftbic">
                  <small class="label">Payment bank swift BIC</small>
                  <vs-input class="w-full" name="payment_bank_swiftbic" type="text" v-model="createForm.payment_bank_swiftbic"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <h6 class="mb-4 mt-6">USD</h6>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank name</small>
                <vs-input class="w-full" name="payment_bank_name" type="text" v-model="createForm.payment_bank_name_usd"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account name</small>
                <vs-input class="w-full" name="payment_bank_account_name" type="text" v-model="createForm.payment_bank_account_name_usd"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank account number</small>
                  <vs-input class="w-full" name="payment_bank_account_number" type="text" v-model="createForm.payment_bank_account_number_usd"/>
              </div>
            </div>
            <div class="vx-row mb3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank sort code</small>
                  <vs-input class="w-full" name="payment_bank_sort_code" type="text" v-model="createForm.payment_bank_sort_code_usd"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank IBN</small>
                  <vs-input class="w-full" name="payment_bank_iban" type="text" v-model="createForm.payment_bank_iban_usd"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank swift BIC</small>
                  <vs-input class="w-full" name="payment_bank_swiftbic" type="text" v-model="createForm.payment_bank_swiftbic_usd"/>
              </div>
            </div>
          </div>

          <h6 class="mb-4 mt-6">EUR</h6>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank name</small>
                <vs-input class="w-full" name="payment_bank_name" type="text" v-model="createForm.payment_bank_name_eur"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account name</small>
                <vs-input class="w-full" name="payment_bank_account_name" type="text" v-model="createForm.payment_bank_account_name_eur"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account number</small>
                <vs-input class="w-full" name="payment_bank_account_number" type="text" v-model="createForm.payment_bank_account_number_eur"/>
              </div>
            </div>
            <div class="vx-row mb3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank sort code</small>
                <vs-input class="w-full" name="payment_bank_sort_code" type="text" v-model="createForm.payment_bank_sort_code_eur"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank IBN</small>
                  <vs-input class="w-full" name="payment_bank_account_number" type="text" v-model="createForm.payment_bank_iban_eur"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank swift BIC</small>
                  <vs-input class="w-full" name="payment_bank_swiftbic" type="text" v-model="createForm.payment_bank_swiftbic_eur"/>
              </div>
            </div>
          
            <h6 class="mb-4 mt-6">AUD</h6>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank name</small>
                <vs-input class="w-full" name="payment_bank_name_aud" type="text" v-model="createForm.payment_bank_name_aud"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account name</small>
                <vs-input class="w-full" name="payment_bank_account_name_aud" type="text" v-model="createForm.payment_bank_account_name_aud"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account number</small>
                <vs-input class="w-full" name="payment_bank_account_number_aud" type="text" v-model="createForm.payment_bank_account_number_aud"/>
              </div>
            </div>
            <div class="vx-row mb3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank sort code</small>
                <vs-input class="w-full" name="payment_bank_clearing_code_aud" type="text" v-model="createForm.payment_bank_clearing_code_aud"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank IBN</small>
                  <vs-input class="w-full" name="payment_bank_iban_aud" type="text" v-model="createForm.payment_bank_iban_aud"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank swift BIC</small>
                  <vs-input class="w-full" name="payment_bank_swiftbic_aud" type="text" v-model="createForm.payment_bank_swiftbic_aud"/>
              </div>
            </div>

            <h6 class="mb-4 mt-6">DKK</h6>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank name</small>
                <vs-input class="w-full" name="payment_bank_name_dkk" type="text" v-model="createForm.payment_bank_name_dkk"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account name</small>
                <vs-input class="w-full" name="payment_bank_account_name_dkk" type="text" v-model="createForm.payment_bank_account_name_dkk"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank account number</small>
                <vs-input class="w-full" name="payment_bank_account_number_dkk" type="text" v-model="createForm.payment_bank_account_number_dkk"/>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <small class="label">Payment bank registration number</small>
                <vs-input class="w-full" name="payment_bank_registration_number_dkk" type="text" v-model="createForm.payment_bank_registration_number_dkk"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank IBAN</small>
                  <vs-input class="w-full" name="payment_bank_iban_dkk" type="text" v-model="createForm.payment_bank_iban_dkk"/>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <small class="label">Payment bank swift BIC</small>
                  <vs-input class="w-full" name="payment_bank_swiftbic_dkk" type="text" v-model="createForm.payment_bank_swiftbic_dkk"/>
              </div>
            </div>

          <div>
            <h5 class="mb-4 mt-16">Working Hours</h5>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider name="working_hour_from" rules="required" v-slot="{ errors }" vid="working_hour_from">
                  <small class="label">From</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                              class="w-full" v-model="createForm.working_hour_from"
                              placeholder="H:m"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider name="working_hour_to" rules="required" v-slot="{ errors }" vid="working_hour_to">
                  <small class="label">To</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                              class="w-full" v-model="createForm.working_hour_to"
                              placeholder="H:m"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div>
            <h5 class="mb-4 mt-16">Delivery Days</h5>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider name="product_delivery_days_uk" rules="required" v-slot="{ errors }"
                                    vid="product_delivery_days_uk">
                  <small class="label">Product Delivery Days UK(Business Days)</small>
                  <vs-input class="w-full" name="product_delivery_days_uk" type="number"
                            v-model="createForm.product_delivery_days_uk"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider name="product_delivery_days_eu" rules="required" v-slot="{ errors }"
                                    vid="product_delivery_days_eu">
                  <small class="label">Product Delivery Days EU(Business Days)</small>
                  <vs-input class="w-full" name="product_delivery_days_eu" type="number"
                            v-model="createForm.product_delivery_days_eu"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider name="product_delivery_days_row" rules="required" v-slot="{ errors }"
                                    vid="product_delivery_days_row">
                  <small class="label">Product Delivery Days row(Business Days)</small>
                  <vs-input class="w-full" name="product_delivery_days_row" type="number"
                            v-model="createForm.product_delivery_days_row"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div>
            <h5 class="mb-4 mt-16">Shelf Location</h5>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_r_from" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_r_from">
                  <small class="label">Shelf Location <span class="font-bold text-md">R</span></small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="working_hour_from" type="text"
                              v-model="createForm.shelf_location_r_from"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_r_to" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_r_to">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="shelf_location_r_to" type="text" v-model="createForm.shelf_location_r_to"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_s_from" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_s_from">
                  <small class="label">Shelf Location <span class="font-bold text-md">S</span></small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="shelf_location_s_from" type="text"
                              v-model="createForm.shelf_location_s_from"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_s_to" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_s_to">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="shelf_location_s_to" type="text" v-model="createForm.shelf_location_s_to"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_l_from" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_l_from">
                  <small class="label">Shelf Location <span class="font-bold text-md">L</span></small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="shelf_location_l_from" type="text"
                              v-model="createForm.shelf_location_l_from"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider name="shelf_location_l_to" rules="required" v-slot="{ errors }"
                                    vid="shelf_location_l_to">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="shelf_location_l_to" type="text" v-model="createForm.shelf_location_l_to"/>
                  </vx-input-group>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3 mt-16">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="mlor_threshold" rules="" v-slot="{ errors }"
                                  vid="mlor_threshold">
                <small class="label">MLOR threshold (%)</small>
                <vs-input class="w-full" name="mlor_threshold" type="text"
                          v-model="createForm.mlor_threshold"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="standard_credit_terms" rules="" v-slot="{ errors }"
                                  vid="standard_credit_terms">
                <small class="label">Standard Credit Terms (days)</small>
                <vs-input class="w-full" name="standard_credit_terms" type="number"
                          v-model="createForm.standard_credit_terms"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <h5 class="mb-4 mt-16">Formulation</h5>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="machine_cost_per_hour" name="machine_cost_per_hour" rules="required|max:40" v-slot="{ errors }">
                <small class="label">Machine cost per hour (GBP)</small>
                <vs-input v-model="createForm.machine_cost_per_hour" class="w-full"  name="machine_cost_per_hour" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="labour_cost_per_hour" name="labour_cost_per_hour" rules="required|max:40" v-slot="{ errors }">
                <small class="label">Labour cost per hour (GBP)</small>
                <vs-input v-model="createForm.labour_cost_per_hour" class="w-full"  name="labour_cost_per_hour" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="formulation_expiration_months" rules="required" v-slot="{ errors }"
                                  vid="formulation_expiration_months">
                <small class="label">Formulation Expiration Months</small>
                <vs-input class="w-full" name="formulation_expiration_months" type="number"
                          v-model="createForm.formulation_expiration_months"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="work_order_variance_percent" name="work_order_variance_percent" rules="" v-slot="{ errors }">
                <small class="label">Manufacturing Variance (increase to plan by %)</small>
                <vs-input v-model="createForm.work_order_variance_percent" class="w-full"  name="work_order_variance_percent" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <!-- <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_clean_hours" rules="required" v-slot="{ errors }" vid="default_formulation_clean_hours">
                <small class="label">Default Formulation Clean Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_clean_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_machine_hours" rules="required" v-slot="{ errors }" vid="default_formulation_machine_hours">
                <small class="label">Default Formulation Machine Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_machine_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div> -->
          <!-- <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider name="default_formulation_labour_hours" rules="required" v-slot="{ errors }" vid="default_formulation_labour_hours">
                <small class="label">Default Formulation Labour Hours</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="createForm.default_formulation_labour_hours"
                            placeholder="H:m"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div> -->
          <h5 class="mb-4 mt-16">Forecast Tool</h5>
          <div class="vx-row mb-8 mt-4">
            <div class="vx-col md:w-1/2 w-full">
                <small class="label">Time Interval</small>
                <v-select :disabled="createForm.sales_marketing_tool_time_interval.length > 0"
                  v-model="createForm.sales_marketing_tool_time_interval" :options="['daily','weekly','monthly']"/>
              <small v-if="createForm.sales_marketing_tool_time_interval.length > 0"
                     class="text-danger">* You cannot change the forecast interval without contacting the administrator.
              </small>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <small class="label">Unit</small>
                <v-select v-model="createForm.sales_marketing_tool_unit" :options="['Kg','g']"/>
            </div>
          </div>
          <h5 class="mb-4 mt-16">Orders</h5>
          <div class="vx-row mb-8 mt-4">
          <div class="vx-col md:w-full w-full">
            <small class="label">Order Special Instructions</small>
            <vs-textarea class="mb-0" v-model="createForm.order_delivery_instructions" height="100px"/>
          </div>
          </div>

          <div v-can="'edit-company-details-setting'" class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import {
    mapGetters,
    mapActions,
  } from 'vuex'
  import moment from "moment";
  const SettingsRepository = RepositoryFactory.get('settings');
  import vSelect from "vue-select";
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "ListOfSettings",
    data() {
      return {
        settings: [],
        createForm: {
          company_name: '',
          address_line_1: '',
          address_line_2: '',
          address_line_3: '',
          town: '',
          post_code: '',
          country: '',
          telephone: '',
          website: '',
          vat_no: '',
          vat_deferred: '',
          company_no: '',
          eori_ni: '',
          eori_eu: '',
          working_hour_from: '',
          working_hour_to: '',
          product_delivery_days_uk: '',
          product_delivery_days_eu: '',
          product_delivery_days_row: '',
          formulation_expiration_months: '',
          shelf_location_r_from: '',
          shelf_location_r_to: '',
          shelf_location_s_from: '',
          shelf_location_s_to: '',
          shelf_location_l_from: '',
          shelf_location_l_to: '',
          mlor_threshold: '',
          standard_credit_terms: '',
          sales_contact_tel: '',
          sales_contact_email: '',
          customer_service_contact_email: '',
          technical_contact_email: '',
          payment_bank_name: '',
          payment_bank_account_name: '',
          payment_bank_account_number: '',
          payment_bank_sort_code: '',
          payment_bank_iban: '',
          payment_bank_swiftbic: '',
          labour_cost_per_hour: '',
          machine_cost_per_hour: '',
          forecast_tool_time_interval: '',
          forecast_tool_unit: '',
          financial_year_start_month: '',
          bespoke_price_check_days: '',
          order_delivery_instructions:'',
          work_order_variance_percent: '',
          payment_bank_name_usd: '',
          payment_bank_account_name_usd: '',
          payment_bank_account_number_usd: '',
          payment_bank_swiftbic_usd: '',
          payment_bank_sort_code_usd: '',
          payment_bank_iban_usd: '',
          payment_bank_name_eur: '',
          payment_bank_account_name_eur: '',
          payment_bank_account_number_eur: '',
          payment_bank_swiftbic_eur: '',
          payment_bank_sort_code_eur: '',
          payment_bank_iban_eur: '',
          payment_bank_name_aud: '',
          payment_bank_account_name_aud: '',
          payment_bank_account_number_aud: '',
          payment_bank_swiftbic_aud: '',
          payment_bank_clearing_code_aud: '',
          payment_bank_iban_aud: '',
          payment_bank_name_dkk: '',
          payment_bank_account_name_dkk: '',
          payment_bank_account_number_dkk: '',
          payment_bank_registration_number_dkk: '',
          payment_bank_iban_dkk: '',
          payment_bank_swiftbic_dkk: '',
          // default_formulation_clean_hours: '',
          // default_formulation_labour_hours: '',
          // default_formulation_machine_hours: '',
          default_sample_item_price: '',
          eori_nl: ''
        }
      }
    },
    async mounted() {
      await this.fetchSettings()
    },
    computed: {
      ...mapGetters(['name']),
    },
    components: {
      flatPickr,
      'v-select':vSelect
    },
    methods: {
      ...mapActions(['updateName']),
      async fetchSettings() {
        this.$vs.loading();
        const {data} = (await SettingsRepository.getListOfSettings()).data;

        // let elements = []
        // for (var key in data) {
        //   if (data.hasOwnProperty(key)) {
        //     elements = [...elements, ...data[key].elements]
        //   }
        // }
        // const formatted_elements = elements.map((x) => {
        //   return { type: x.type, label: x.label, name: x.name, value: x.value }
        // })


        this.createForm.company_name = data.company_name.elements[0].value;
        this.createForm.address_line_1 = data.address_line_1.elements[0].value;
        this.createForm.address_line_2 = data.address_line_2.elements[0].value;
        this.createForm.address_line_3 = data.address_line_3.elements[0].value;
        this.createForm.town = data.town.elements[0].value;
        this.createForm.post_code = data.post_code.elements[0].value;
        this.createForm.country = data.country.elements[0].value;
        this.createForm.telephone = data.telephone.elements[0].value;
        this.createForm.website = data.website.elements[0].value;

        this.createForm.vat_no = data.vat_no.elements[0].value;
        this.createForm.vat_deferred = data.vat_deferred.elements[0].value;
        this.createForm.company_no = data.company_no.elements[0].value;
        this.createForm.eori_ni = data.eori_ni.elements[0].value;
        this.createForm.eori_eu = data.eori_eu.elements[0].value;
        this.createForm.financial_year_start_month = data.financial_year_start_month ? data.financial_year_start_month.elements[0].value : '';

        this.createForm.mlor_threshold = data.mlor_threshold.elements[0].value;
        this.createForm.working_hour_from = this.__utcToLocalTime(data.working_hours.elements[0].value);
        this.createForm.working_hour_to = this.__utcToLocalTime(data.working_hours.elements[1].value);

        this.createForm.product_delivery_days_uk = data.product_delivery_days_uk.elements[0].value;
        this.createForm.product_delivery_days_eu = data.product_delivery_days_eu.elements[0].value;
        this.createForm.product_delivery_days_row = data.product_delivery_days_row.elements[0].value;

        this.createForm.formulation_expiration_months = data.formulation_expiration_months.elements[0].value;

        this.createForm.shelf_location_r_from = data.shelf_location_r.elements[0].value;
        this.createForm.shelf_location_r_to = data.shelf_location_r.elements[1].value;

        this.createForm.shelf_location_s_from = data.shelf_location_s.elements[0].value;
        this.createForm.shelf_location_s_to = data.shelf_location_s.elements[1].value;

        this.createForm.shelf_location_l_from = data.shelf_location_l.elements[0].value;
        this.createForm.shelf_location_l_to = data.shelf_location_l.elements[1].value;

        this.createForm.standard_credit_terms = data.standard_credit_terms.elements[0].value;

        this.createForm.sales_contact_tel = data.sales_contact_tel.elements[0].value;
        this.createForm.sales_contact_email = data.sales_contact_email.elements[0].value;
        this.createForm.customer_service_contact_email = data.customer_service_contact_email.elements[0].value;
        this.createForm.technical_contact_email = data.technical_contact_email.elements[0].value;

        this.createForm.payment_bank_name = data.payment_bank_name.elements[0].value;
        this.createForm.payment_bank_account_name = data.payment_bank_account_name.elements[0].value;
        this.createForm.payment_bank_account_number = data.payment_bank_account_number.elements[0].value;
        this.createForm.payment_bank_sort_code = data.payment_bank_sort_code.elements[0].value;
        this.createForm.payment_bank_iban = data.payment_bank_iban.elements[0].value;
        this.createForm.payment_bank_swiftbic = data.payment_bank_swiftbic.elements[0].value;

        this.createForm.labour_cost_per_hour = data.labour_cost_per_hour.elements[0].value;
        this.createForm.machine_cost_per_hour = data.machine_cost_per_hour.elements[0].value;

        this.createForm.sales_marketing_tool_time_interval = data.sales_marketing_tool_time_interval ? data.sales_marketing_tool_time_interval.elements[0].value: ''
        this.createForm.sales_marketing_tool_unit = data.sales_marketing_tool_unit ? data.sales_marketing_tool_unit.elements[0].value : ''
        this.createForm.order_delivery_instructions = data.order_delivery_instructions.elements[0].value

        this.createForm.work_order_variance_percent = data.work_order_variance_percent.elements[0].value

        this.createForm.payment_bank_name_usd = data.payment_bank_name_usd.elements[0].value
        this.createForm.payment_bank_account_name_usd = data.payment_bank_account_name_usd.elements[0].value
        this.createForm.payment_bank_account_number_usd = data.payment_bank_account_number_usd.elements[0].value
        this.createForm.payment_bank_swiftbic_usd = data.payment_bank_swiftbic_usd.elements[0].value
        this.createForm.payment_bank_sort_code_usd = data.payment_bank_sort_code_usd.elements[0].value;
        this.createForm.payment_bank_iban_usd = data.payment_bank_iban_usd.elements[0].value;

        this.createForm.payment_bank_name_eur = data.payment_bank_name_eur.elements[0].value
        this.createForm.payment_bank_account_name_eur = data.payment_bank_account_name_eur.elements[0].value
        this.createForm.payment_bank_account_number_eur = data.payment_bank_account_number_eur.elements[0].value
        this.createForm.payment_bank_iban_eur = data.payment_bank_iban_eur.elements[0].value
        this.createForm.payment_bank_sort_code_eur = data.payment_bank_sort_code_eur.elements[0].value;
        this.createForm.payment_bank_swiftbic_eur = data.payment_bank_swiftbic_eur.elements[0].value

        this.createForm.payment_bank_name_aud = data.payment_bank_name_aud.elements[0].value
        this.createForm.payment_bank_account_name_aud = data.payment_bank_account_name_aud.elements[0].value
        this.createForm.payment_bank_account_number_aud = data.payment_bank_account_number_aud.elements[0].value
        this.createForm.payment_bank_iban_aud = data.payment_bank_iban_aud.elements[0].value
        this.createForm.payment_bank_clearing_code_aud = data.payment_bank_clearing_code_aud.elements[0].value;
        this.createForm.payment_bank_swiftbic_aud = data.payment_bank_swiftbic_aud.elements[0].value

        this.createForm.payment_bank_name_dkk = data.payment_bank_name_dkk && data.payment_bank_name_dkk.elements && data.payment_bank_name_dkk.elements[0] ? data.payment_bank_name_dkk.elements[0].value : ''
        this.createForm.payment_bank_account_name_dkk = data.payment_bank_account_name_dkk && data.payment_bank_account_name_dkk.elements && data.payment_bank_account_name_dkk.elements[0] ? data.payment_bank_account_name_dkk.elements[0].value : ''
        this.createForm.payment_bank_account_number_dkk = data.payment_bank_account_number_dkk && data.payment_bank_account_number_dkk.elements && data.payment_bank_account_number_dkk.elements[0] ? data.payment_bank_account_number_dkk.elements[0].value : ''
        this.createForm.payment_bank_registration_number_dkk = data.payment_bank_registration_number_dkk && data.payment_bank_registration_number_dkk.elements && data.payment_bank_registration_number_dkk.elements[0] ? data.payment_bank_registration_number_dkk.elements[0].value : ''
        this.createForm.payment_bank_iban_dkk = data.payment_bank_iban_dkk && data.payment_bank_iban_dkk.elements && data.payment_bank_iban_dkk.elements[0] ? data.payment_bank_iban_dkk.elements[0].value : ''
        this.createForm.payment_bank_swiftbic_dkk = data.payment_bank_swiftbic_dkk && data.payment_bank_swiftbic_dkk.elements && data.payment_bank_swiftbic_dkk.elements[0] ? data.payment_bank_swiftbic_dkk.elements[0].value : ''

        this.createForm.bespoke_price_check_days = data.bespoke_price_check_days.elements[0].value

        // this.createForm.default_formulation_clean_hours = data.default_formulation_clean_hours ? data.default_formulation_clean_hours.elements[0].value : '';
        // this.createForm.default_formulation_labour_hours = data.default_formulation_labour_hours ? data.default_formulation_labour_hours.elements[0].value : '';
        // this.createForm.default_formulation_machine_hours = data.default_formulation_machine_hours ? data.default_formulation_machine_hours.elements[0].value : '';

        this.createForm.default_sample_item_price = data.default_sample_item_price.elements[0].value
        this.createForm.eori_nl = data.eori_nl.elements[0].value


        this.$vs.loading.close()
      },

      async onClickUpdateSettings() {
        this.$vs.loading();
        try {
          const payload = {}
          await Object.assign(payload, this.createForm)
          payload.working_hour_from = moment(this.createForm.working_hour_from, 'HH:mm').utc().format('HH:mm')
          payload.working_hour_to = moment(this.createForm.working_hour_to, 'HH:mm').utc().format('HH:mm')
          payload.labour_cost_per_hour = Number(this.createForm.labour_cost_per_hour).toFixed(2)
          payload.machine_cost_per_hour = Number(this.createForm.machine_cost_per_hour).toFixed(2)
          const change = await SettingsRepository.updateSettings(payload);
          this.showSuccessMessage('Settings Updated Successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

